import { NgModule } from 'angular-ts-decorators';
import { DesignModule } from 'src/Foundation/Design/platform';

import { CategoryFaqItemComponent } from './category-faq-item/category-faq-item.component';
import { CategoryFaqsComponent } from "./category-faqs/category-faqs.component";

@NgModule({
    declarations: [
        CategoryFaqsComponent,
        CategoryFaqItemComponent,
    ],
    id: 'gn.audio.public.store-support',
    imports: [DesignModule],
  })
  export class StoreSupportModule {
  }
